export default __webpack_public_path__ + "static/media/14KYCDetailsYono2@3x.a3f2aeef.png";